/**
 * Brand marks that render in the first paint of every page, served from this
 * origin rather than cdn.sticko.app.
 *
 * Above-the-fold images from the CDN cost a second TLS connection before the
 * header can finish (≈0.8 s for the first CDN request on a cold mobile load,
 * against ≈0.1 s for sticko.app, measured 2026-10-03), and React hoists them
 * into <link rel="preload"> at the top of <head>. Same-origin, they ride the
 * connection the HTML already opened. Copies of
 * cdn.sticko.app/static-content/{sticko-logo,sticko-text-logo}.svg — keep the
 * files in public/static/ in step if the brand changes.
 *
 * The Organization JSON-LD logo stays on the CDN URL: it is an identifier
 * crawlers have already seen, not a render dependency.
 */
export const SAME_ORIGIN_LOGO = "/static/sticko-logo.svg";
export const SAME_ORIGIN_WORDMARK = "/static/sticko-text-logo.svg";
